var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _vm.loading
        ? _c("v-progress-linear", {
            staticClass: "p-1 pt-0",
            attrs: {
              indeterminate: true,
              color: "green",
              height: "5"
            }
          })
        : _c(
            "v-form",
            [
              _c("gg-text-field", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|max:".concat(_vm.maxlength),
                    expression: "`required|max:${maxlength}`"
                  }
                ],
                attrs: {
                  label: "New Database",
                  name: "New Database",
                  prefix: _vm.newDBPrefix,
                  counter: _vm.maxlength,
                  "error-messages": _vm.errors.collect("New Database")
                },
                model: {
                  value: _vm.newDBName,
                  callback: function callback($$v) {
                    _vm.newDBName = $$v
                  },
                  expression: "newDBName"
                }
              }),
              _vm.submitButton
                ? _c(
                    "gg-btn",
                    {
                      staticClass: "ml-0",
                      attrs: {
                        loading: _vm.isLoading
                      },
                      on: {
                        click: _vm.createDatabase
                      }
                    },
                    [_vm._v(" Create Database ")]
                  )
                : _vm._e()
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }